<div class="alert" [class]="['alert-' + severity, agencyService.agencyMode ? 'alert-agency' : null]">
  <ng-content></ng-content>
</div>
